import { State } from "@/store/modules/poll/index";

const getPoll = (state: State): any => {
    return state.poll;
};

const getPollTime = (state: State): any => {
    return state.pollTime;
};

export default {
    getPoll,
    getPollTime
};